module.exports = "/images/london-3.jpg";